export const GENERIC_ERROR = {
  title: 'Ocorreu um erro no pagamento!',
  message:
    'Houve um erro ao processar sua compra. Tente novamente mais tarde ou utilize outra forma de pagamento.'
};

const GENERIC_CC_ERROR = {
  title: 'Ocorreu um erro no pagamento!',
  message:
    'Houve um erro ao processar sua compra. Tente novamente com outro cartão ou utilize outra forma de pagamento.'
};

const GENERIC_BNPL_ERROR = {
  title: 'Ocorreu um erro!',
  message:
    'Por favor, recarregue a página de tente novamente. Caso o erro persista, entre em contato com o nosso suporte.'
};

export const errorMapping = {
  cc_rejected_other_reason: GENERIC_CC_ERROR,
  cc_rejected_blacklist: GENERIC_CC_ERROR,
  cc_rejected_card_error: GENERIC_CC_ERROR,
  cc_rejected_high_risk: GENERIC_CC_ERROR,
  cc_rejected_bad_filled_card_number: {
    title: 'Número do cartão inválido!',
    message:
      'O número do cartão parece estar incorreto.<br>Revise com atenção os dados preenchidos e tente novamente.'
  },
  cc_rejected_bad_filled_date: {
    title: 'Data de vencimento inválida!',
    message:
      'O pagamento não foi processado. Revise com atenção os dados de validade do cartão e tente novamente.'
  },
  cc_rejected_bad_filled_other: {
    title: 'Dados do cartão inválidos!',
    message:
      'As informações do cartão estão incorretas. Revise com atenção os dados preenchidos e tente novamente.'
  },
  cc_rejected_bad_filled_security_code: {
    title: 'Código de segurança inválido!',
    message:
      'Seu pagamento não foi processado. Revise com atenção o código de segurança e tente novamente.'
  },
  cc_rejected_call_for_authorize: {
    title: 'Pagamento não autorizado!',
    message:
      'Entre em contato com o banco para autorizar a compra e tente novamente. Você também pode tentar utilizar outro cartão ou outra forma de pagamento.'
  },
  cc_rejected_card_disabled: {
    title: 'Este cartão não está ativo!',
    message:
      'Parece que este cartão ainda não foi ativado. Entre em contato com o banco para ativá-lo, ou tente novamente utilizando outro cartão.'
  },
  cc_rejected_duplicated_payment: {
    title: 'Pagamento duplicado!',
    message:
      'Identificamos um pagamento recente no mesmo valor. Aguarde alguns minutos e tente novamente.'
  },
  cc_rejected_insufficient_amount: {
    title: 'Este cartão não possui limite!',
    message:
      'O cartão utilizado não possui saldo suficiente pra efetuar a compra. Tente novamente usando outro cartão ou outra forma de pagamento.'
  },
  cc_rejected_invalid_installments: {
    title: 'Ocorreu um erro no pagamento!',
    message:
      'Este cartão não permite o número de parcelas escolhido. Tente novamente com outro cartão ou utilize outra forma de pagamento.'
  },
  cc_rejected_max_attempts: {
    title: 'Limite de tentativas excedido!',
    message:
      'Você atingiu o limite de tentativas neste cartão. Tente novamente com outro cartão ou utilize outra forma de pagamento.'
  },
  payer_unavailable: {
    title: 'Ocorreu um erro no pagamento!',
    message:
      'O pagamento não foi processado. Entre em contato com o nosso suporte para que possamos ajudar você!'
  },
  session_expired: {
    title: 'Sessão expirada!',
    message:
      'Ops, sua sessão expirou! Atualize sua página e selecione o produto desejado novamente.'
  },
  rejected_by_bank: {
    title: 'Pagamento rejeitado!',
    message:
      'Seu pagamento não foi aprovado pelo banco. Tente novamente com outra forma de pagamento.'
  },
  bnpl_fraud_id: GENERIC_BNPL_ERROR,
  bnpl_api_error: GENERIC_BNPL_ERROR,
  access_denied: {
    title: 'Não foi possível concluir a autorização',
    message:
      'Verificamos o CPF informado e não conseguimos encontrar sua autorização no Nubank.'
  },
  unauthorized_client: {
    title: 'Não foi possível concluir a autorização',
    message:
      'Verificamos o CPF informado e não conseguimos encontrar sua conta no Nubank.'
  },
  unavaliable_payment_conditions: {
    title: 'Não encontramos meios de pagamento disponíveis',
    message:
      'O meio de pagamento Nubank não está disponível para este CPF. Tente novamente com outro meio de pagamento ou com outro CPF.'
  },
  nupay_auth_server_error: {
    title: 'Não conseguimos finalizar sua solicitação',
    message:
      'Aguarde alguns instantes e tente novamente. Caso o erro persista, entre em contato com o nosso suporte.'
  },
  transaction_failed: {
    title: 'Não foi possível concluir a autorização',
    message:
      'Devido a falta de saldo suficiente e limite de crédito na sua conta do Nubank, não conseguimos concluir a autorização.'
  },
  invalid_grant: {
    title: 'Não foi possível concluir a autorização',
    message: 'Não identificamos sua autorização'
  },
  invalid_client: {
    title: 'Não foi possível concluir a autorização',
    message: 'Verifique os dados informados e tente novamente.'
  },
  invalid_request: {
    title: 'Não foi possível concluir',
    message: 'Verifique os dados informados e tente novamente.'
  },
  invalid_scope: {
    title: 'Não foi possível concluir',
    message: 'Verifique os dados informados e tente novamente.'
  },
  server_error: {
    title: 'Não foi possível concluir',
    message: 'Verifique os dados informados e tente novamente.'
  },
  temporarily_unavailable: {
    title: 'Não foi possível concluir',
    message: 'Verifique os dados informados e tente novamente.'
  },
  bnpl_koin_error: {
    title: 'Ocorreu um erro!',
    message: null
  },
  bnpl_wrong_input: {
    title: 'Ocorreu um erro no Preenchimento!',
    message: 'Preencha todos os campos corretamente e tente de novo.'
  },
  coupon_invalid: {
    title: 'Cupom inválido!',
    message: 'Este cupom está inválido. Tente utilizar outro.'
  },
  coupon_invalid_for_offer: {
    title: 'Cupom inválido!',
    message: 'Este cupom não é válido para essa oferta.'
  },
  coupon_expired: {
    title: 'Promoção encerrada!',
    message:
      'Este cupom não está mais disponível porque a promoção já foi encerrada. Tente utilizar um cupom promocional ativo'
  },
  coupon_redeemed: {
    title: 'Cupom de desconto esgotado!',
    message:
      'Parece que todos os cupons disponíveis para esta promoção já foram utilizados. Tente utilizar um cupom ainda ativo.'
  },
  coupon_referral_self: {
    title: 'Você não pode utilizar este cupom!',
    message:
      'Seu cupom de desconto só pode ser utilizado por outros alunos. Tente utilizar um outro cupom.'
  },
  coupon_remove_error: {
    title: 'Houve um erro ao remover o cupom.',
    message: 'Atualize a página e tente novamente.'
  },
  coupon_global_monthly: {
    title: 'Cupom não aplicável nesta oferta!',
    message:
      'Esse cupom não é válido para ofertas mensais. Você pode aplicá-lo em outras ofertas.'
  },
  coupon_already_used: {
    title: 'Cupom já utilizado!',
    message: 'Esse cupom só permite 1 uso por aluno.'
  }
};
